import GolfClubRepository from "./GolfClubRepository";

const repositories = {
    golfClub: GolfClubRepository,
};

export const RepositoryFactory = {
    get: (name) => repositories[name],
};
